class BBSHeader {
  constructor() {
    this.searchOverlay = document.querySelector('[data-bbs-search-overlay]');
    this.drawer = document.querySelector('[data-bbs-drawer]');
    this.bindEvents();
  }

  bindEvents() {
    document.querySelectorAll('[data-bbs-search-open]').forEach((btn) => {
      btn.addEventListener('click', () => this.openSearch());
    });
    document.querySelectorAll('[data-bbs-search-close]').forEach((btn) => {
      btn.addEventListener('click', () => this.closeSearch());
    });
    document.querySelector('[data-bbs-menu-open]')?.addEventListener('click', () => this.openDrawer());
    document.querySelector('[data-bbs-menu-close]')?.addEventListener('click', () => this.closeDrawer());
    this.drawer?.addEventListener('click', (e) => {
      if (e.target === this.drawer) this.closeDrawer();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeSearch();
        this.closeDrawer();
      }
    });
  }

  openSearch() {
    if (!this.searchOverlay) return;
    this.searchOverlay.classList.add('is-open');
    this.searchOverlay.setAttribute('aria-hidden', 'false');
    this.searchOverlay.querySelector('input')?.focus();
  }

  closeSearch() {
    if (!this.searchOverlay) return;
    this.searchOverlay.classList.remove('is-open');
    this.searchOverlay.setAttribute('aria-hidden', 'true');
  }

  openDrawer() {
    if (!this.drawer) return;
    this.drawer.classList.add('is-open');
    this.drawer.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }

  closeDrawer() {
    if (!this.drawer) return;
    this.drawer.classList.remove('is-open');
    this.drawer.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const headerBar = document.querySelector('[data-bbs-header]');
  const header = headerBar?.querySelector('.bbs-header');
  if (headerBar && header) {
    const setHeaderHeight = () => {
      headerBar.style.setProperty('--bbs-header-bar-height', `${header.offsetHeight}px`);
    };
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);
  }

  if (headerBar) {
    new BBSHeader();
  }
});
